module.exports = __webpack_public_path__ + "static/media/report-a-bug-modal.d9944161.png";